import React from "react";
import SectionCard from "@components/SectionCard/SectionCard";

interface SettingsSectionCardProps {
  sectionOffset: number;
  title: string;
  action?: JSX.Element;
  bodyClassName?: string;
  children: React.ReactNode;
}

export const SettingsSectionCard: React.FC<SettingsSectionCardProps> = ({
  sectionOffset,
  title,
  action,
  bodyClassName,
  children,
}) => (
  <SectionCard number={sectionOffset} title={title} action={action}>
    <div className={`configure-connection-view__section-body${bodyClassName ? ` ${bodyClassName}` : ""}`}>{children}</div>
  </SectionCard>
);
